
// ROUTES
require('modules/invitation-group/routes/invitation-group');

// CONTROLLERS
require('modules/invitation-group/controllers/invitation-group');
require('modules/invitation-group/controllers/list');
require('modules/invitation-group/controllers/create');
require('modules/invitation-group/controllers/edit');
require('modules/invitation-group/controllers/assign');


// SERVICES
require('modules/invitation-group/services/invitation-group');
require('modules/invitation-group/services/list');
require('modules/invitation-group/services/create');
require('modules/invitation-group/services/edit');
require('modules/invitation-group/services/delete');
require('modules/invitation-group/services/assign');



angular.module('unica_invitation_group', [

	// ROUTES
	'unica_invitation_group.invitation_group_routes',

	// CONTROLLERS
	'unica_invitation_group.invitation_group_controllers',

	// SERVICES
	'unica_invitation_group.invitation_group_services'

]);